import { type ProductOption } from "@kanpla/api-contract";
import { clsx } from "clsx";
import { type PropsWithChildren } from "react";

type VariantGroupProps = PropsWithChildren & {
  name: ProductOption["name"];
  className?: string;
};

export const VariantSection = ({
  name,
  children,
  className
}: VariantGroupProps) => {
  return (
    <div
      className={clsx(
        "flex w-full flex-col items-start gap-2 px-10",
        className
      )}
    >
      <p className="text-4xl font-bold">{name}</p>

      <div className="flex w-full flex-col gap-4">{children}</div>
    </div>
  );
};
